import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, IconContainer, P, H4 } from '@allied-solutions/affinity'
import {
  Search,
  SuccessSolid,
  Close03,
  ErrorSolid,
  ClockSolid,
  WarningSolid,
  Shield02,
} from '@allied-solutions/affinity-react-icons/standard'

const STATUS_ICON_BY_NAME = {
  ClockSolid,
  WarningSolid,
  Search,
  Close03,
  ErrorSolid,
  Shield02,
  SuccessSolid,
}

const resolveStatusIcon = icon =>
  typeof icon === 'string' ? STATUS_ICON_BY_NAME[icon] : icon

const StyledStatusCard = styled(Box)`
  border-width: 1px;
  border-style: solid;
  border-radius: ${props => props.theme.radii.md};
  max-width: 280px;
`

const formatDate = value => {
  if (value == null || value === '') return ''
  const date = value instanceof Date ? value : new Date(value)
  if (!Number.isNaN(date.getTime())) {
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    })
  }
  return typeof value === 'string' ? value : ''
}

export const DashboardTileStatusCard = ({
  accountStatusDetails,
  EffectiveDate,
}) => {
  if (!accountStatusDetails) return null

  return (
    <StyledStatusCard
      p="3xl"
      bg={accountStatusDetails.bg}
      borderColor={accountStatusDetails.borderColor}
      mb="0"
    >
      <Box display="flex" gap="xl" alignItems="center">
        <IconContainer
          icon={resolveStatusIcon(accountStatusDetails.icon)}
          color={accountStatusDetails.iconColor}
          solid
        />
        <Box>
          <H4 typeStyle="labelLarge.bold" mb={0}>
            {accountStatusDetails.condensedCardHeader}
          </H4>
          <P typeStyle="bodyMedium" color="text.secondary" mb={0}>
            {formatDate(EffectiveDate)}
          </P>
        </Box>
      </Box>
    </StyledStatusCard>
  )
}

DashboardTileStatusCard.propTypes = {
  accountStatusDetails: PropTypes.object,
  EffectiveDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
}
